import React from 'react'
import SettingsPage from './settingsPage'
import Sidebar from '../components/sidebar'

const Settings = () => {
  return (
    <div>
         <SettingsPage />
    </div>
    // <div className="flex w-[100%] h-[100vh] bg-white dark:bg-gray-900">
    // <Sidebar
    //   conversations={null}
    //   handleSelectConversation={null}
    // />
    // <div className="flex-grow overflow-hidden rounded-2xl lg:my-2 ml-2 lg:ml-[30px] lg:mr-2">
     
    // </div>
  )
}

export default Settings